module.exports = __webpack_public_path__ + "static/media/minaperulogo.24cae9a0.png";